var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09478 1.92837C9.45471 1.16162 10.5453 1.16162 10.9052 1.92838L12.8635 6.10005C13.0051 6.40163 13.2875 6.6129 13.6168 6.66351L18.0777 7.34914C18.882 7.47275 19.2098 8.45394 18.6413 9.03614L15.3527 12.4042C15.1309 12.6314 15.0302 12.9505 15.0813 13.2638L15.8484 17.9672C15.9828 18.7911 15.1081 19.4073 14.3776 19.0033L10.4839 16.8501C10.1828 16.6836 9.8172 16.6836 9.51608 16.8501L5.62245 19.0033C4.89189 19.4073 4.01718 18.7911 4.15157 17.9672L4.91872 13.2638C4.96983 12.9505 4.86909 12.6314 4.64727 12.4042L1.35869 9.03614C0.790242 8.45394 1.11804 7.47275 1.92229 7.34914L6.38318 6.66351C6.71247 6.6129 6.99492 6.40163 7.13649 6.10005L9.09478 1.92837Z",
    fill: "#14142B",
    fillOpacity: 0.17,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.93d01f32bf9f2089fd19ba53030f9de6.svg";
export { ForwardRef as ReactComponent };